var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-main",
        [
          _vm.user_uid
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "video-background" },
                  [
                    _c(
                      "video",
                      {
                        staticClass: "video",
                        attrs: { autoplay: "", muted: "", loop: "" },
                        domProps: { muted: true },
                      },
                      [
                        _c("source", {
                          attrs: {
                            src: "/static/video/emotional-1.mp4",
                            type: "video/mp4",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "overlay" }),
                    _vm._v(" "),
                    _c(
                      "v-container",
                      {
                        staticClass: "on-video-background",
                        attrs: { fluid: "" },
                      },
                      [
                        _c(
                          "v-toolbar",
                          {
                            staticClass: "app-bar",
                            attrs: { flat: "", color: "transparent" },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass: "white--text font-weight-bold",
                                on: { click: _vm.gotoHome },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c("img", {
                                      staticClass: "logo",
                                      attrs: {
                                        src:
                                          _vm.firebase_host +
                                          "/static/img/logo.png",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      { staticClass: "font-hemi-head" },
                                      [_vm._v("ASTA LIVE")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            !_vm.is_mobile
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#come-funziona",
                                            expression: "'#come-funziona'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Come funziona\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#prezzi",
                                            expression: "'#prezzi'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Prezzi\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#leghe",
                                            expression: "'#leghe'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Leghe\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                        on: { click: _vm.logout },
                                      },
                                      [_vm._v("Logout\n              ")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: { click: _vm.logout },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "white--text" },
                                          [_vm._v("logout")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.drawer = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "white--text" },
                                          [_vm._v("menu")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12",
                                  md: "6",
                                  "offset-md": "3",
                                },
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "pa-4 navy darken-2 text-center mx-auto my-5",
                                    attrs: {
                                      "min-height": "250px",
                                      width: "450px",
                                    },
                                  },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass: "white--text",
                                        attrs: { id: "saluto" },
                                      },
                                      [
                                        _vm._v("\n                  Ciao"),
                                        _c("br"),
                                        _vm._v(
                                          _vm._s(_vm.displayName) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "py-4 px-10 white--text my-5",
                                        attrs: {
                                          rounded: "",
                                          "x-large": "",
                                          color: "secondary",
                                        },
                                        on: { click: _vm.gotoCreaAsta },
                                      },
                                      [_vm._v("Crea Asta")]
                                    ),
                                    _vm._v(" "),
                                    _c("lista-aste"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "video-background" },
                  [
                    _c(
                      "video",
                      {
                        staticClass: "video",
                        attrs: { autoplay: "", muted: "", loop: "" },
                        domProps: { muted: true },
                      },
                      [
                        _c("source", {
                          attrs: {
                            src: "/static/video/emotional-1.mp4",
                            type: "video/mp4",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "overlay" }),
                    _vm._v(" "),
                    _c(
                      "v-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            staticClass: "app-bar",
                            attrs: { flat: "", color: "transparent" },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass: "white--text font-weight-bold",
                                on: { click: _vm.gotoHome },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c("img", {
                                      staticClass: "logo",
                                      attrs: {
                                        src:
                                          _vm.firebase_host +
                                          "/static/img/logo.png",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      { staticClass: "font-hemi-head" },
                                      [_vm._v("ASTA LIVE")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            !_vm.is_mobile
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#come-funziona",
                                            expression: "'#come-funziona'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Come funziona\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#prezzi",
                                            expression: "'#prezzi'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Prezzi\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "scroll-to",
                                            rawName: "v-scroll-to",
                                            value: "#leghe",
                                            expression: "'#leghe'",
                                          },
                                        ],
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                      },
                                      [_vm._v("Leghe\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "white--text font-weight-bold font-hemi-head",
                                        attrs: { text: "", "x-large": "" },
                                        on: { click: _vm.gotoLogin },
                                      },
                                      [_vm._v("Login\n              ")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: { click: _vm.gotoLogin },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "white--text" },
                                          [_vm._v("account_circle")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.drawer = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "white--text" },
                                          [_vm._v("menu")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "7", lg: "7" } },
                              [
                                _c("div", { staticClass: "titolo" }, [
                                  _c(
                                    "h1",
                                    {
                                      staticClass: "font-hemi-head",
                                      style: {
                                        fontSize: _vm.titoloFontSize + "px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Aste Fantacalcio\n                  "
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "typedElementWrapper" },
                                        [
                                          _c(
                                            "vue-typed-js",
                                            {
                                              attrs: {
                                                strings: _vm.typedStrings,
                                                backDelay: 1000,
                                                typeSpeed: 70,
                                                fadeOut: true,
                                                loop: true,
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "typing",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4", lg: "4" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "pa-4 mx-auto my-xs-4 my-md-16 d-flex flex-column justify-space-between",
                                    attrs: { width: "350px", height: "500px" },
                                  },
                                  [
                                    _vm.calciatoreBattuto
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "calciatore-battuto-wrapper",
                                          },
                                          [
                                            _c("calciatore-battuto", {
                                              staticClass: "magictime",
                                              class:
                                                _vm.calciatoreBattutoAnimation,
                                              attrs: {
                                                id: _vm.calciatoreBattuto,
                                                xLarge: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "face face1 magictime",
                                                class: _vm.faceAnimation1,
                                              },
                                              [
                                                _c("crediti", {
                                                  attrs: {
                                                    crediti:
                                                      _vm.creditiIniziali,
                                                    variant: "dark",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "face face2 magictime",
                                                class: _vm.faceAnimation2,
                                              },
                                              [
                                                _c("crediti", {
                                                  attrs: {
                                                    crediti:
                                                      _vm.creditiIniziali + 6,
                                                    variant: "dark",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "face face3 magictime",
                                                class: _vm.faceAnimation3,
                                              },
                                              [
                                                _c("crediti", {
                                                  attrs: {
                                                    crediti:
                                                      _vm.creditiIniziali + 9,
                                                    variant: "dark",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "face face4 magictime",
                                                class: _vm.faceAnimation4,
                                              },
                                              [
                                                _c("crediti", {
                                                  attrs: {
                                                    crediti:
                                                      _vm.creditiIniziali + 10,
                                                    variant: "dark",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "assegnato magictime",
                                                class: _vm.assegnatoAnimation,
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Assegnato!\n                    "
                                                ),
                                                _c("span", [
                                                  _c("img", {
                                                    attrs: {
                                                      src: "/static/img/face-4.jpg",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.creditiIniziali + 10
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c("v-skeleton-loader", {
                                          attrs: {
                                            width: "100%",
                                            height: "183.5",
                                            type: "list-item-avatar-three-line, list-item-two-line",
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "handwritten font-handwritten",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "Il divertimento comincia qui"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: {
                                            src: "/static/img/arrow.png",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mb-4",
                                            attrs: {
                                              depressed: "",
                                              block: "",
                                              rounded: "",
                                              "x-large": "",
                                              color: "secondary",
                                            },
                                            on: { click: _vm.gotoCreaAsta },
                                          },
                                          [_vm._v("Crea Asta")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mb-4",
                                            attrs: {
                                              depressed: "",
                                              block: "",
                                              rounded: "",
                                              "x-large": "",
                                              outlined: "",
                                              color: "secondary",
                                            },
                                            on: { click: _vm.gotoLogin },
                                          },
                                          [_vm._v("Accedi")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "mt-4 spaceInUp magictime animation-infinite",
              attrs: { large: "" },
            },
            [_vm._v("\n      expand_more\n    ")]
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "white--text px-4 pt-4 font-hemi-head",
              style: { fontSize: _vm.sottoTitoloFontSizePx },
              attrs: { id: "modalita" },
            },
            [
              _c("span", { style: { fontSize: _vm.titoloFontSize + "px" } }, [
                _vm._v(_vm._s(_vm._.size(_vm.Constants.ASTA_MODE))),
              ]),
              _vm._v("\n      Modalità d'Asta\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                _vm._l(_vm.Constants.ASTA_MODE, function (asta_mode) {
                  return _c(
                    "v-col",
                    { key: asta_mode, attrs: { cols: "12", md: "6", lg: "3" } },
                    [
                      _c(
                        "v-card",
                        {
                          directives: [
                            {
                              name: "observe-visibility",
                              rawName: "v-observe-visibility",
                              value: {
                                callback: function (isVisible, entry) {
                                  return _vm.visibilityChanged(
                                    isVisible,
                                    asta_mode
                                  )
                                },
                                once: true,
                                throttle: 0,
                              },
                              expression:
                                "{\n              callback: (isVisible, entry) =>\n                visibilityChanged(isVisible, asta_mode),\n              once: true,\n              throttle: 0,\n            }",
                            },
                          ],
                          staticClass: "asta-mode ma-4 navy darken-3",
                          class: _vm.cardAnimations[asta_mode],
                          attrs: { elevation: "0" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "gradiented" },
                            [
                              _c("v-img", {
                                attrs: {
                                  contain: "",
                                  src:
                                    "/static/img/asta-mode-" +
                                    asta_mode +
                                    ".png",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pa-5" },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "white--text" },
                                    [
                                      _c(
                                        "h2",
                                        { staticClass: "font-hemi-head" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getAstaModeName(asta_mode)
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-subtitle",
                                    {
                                      staticClass:
                                        "px-4 py-4 text-left text--text text--lighten-3",
                                    },
                                    [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getAstaModeShortDescr(asta_mode)
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "pl-4",
                                          attrs: {
                                            color: "secondary",
                                            rounded: "",
                                            depressed: "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleShowMode(
                                                asta_mode
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Dimmi di più\n                    "
                                          ),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.showMode[asta_mode]
                                                    ? "expand_less"
                                                    : "expand_more"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-expand-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showMode[asta_mode],
                                    expression: "showMode[asta_mode]",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("div", {
                                      staticClass:
                                        "text-justify mb-2 text--text text--lighten-3",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getAstaModeLongDescr(asta_mode)
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "secondary" } },
                                      [_vm._v(" school ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "white--text pa-4 font-hemi-head",
              style: { fontSize: _vm.sottoTitoloFontSizePx },
              attrs: { id: "come-funziona" },
            },
            [_vm._v("\n      Come funziona\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pa-6" }, [_c("come-funziona")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "mt-16", attrs: { id: "leghe" } }, [
            _c(
              "div",
              { staticClass: "video-background" },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: { autoplay: "", muted: "", loop: "" },
                    domProps: { muted: true },
                  },
                  [
                    _c("source", {
                      attrs: {
                        src: "/static/video/emotional-2.mp4",
                        type: "video/mp4",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "overlay" }),
                _vm._v(" "),
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "7", lg: "7" } },
                          [
                            _c("div", { staticClass: "titolo" }, [
                              _c(
                                "h1",
                                {
                                  staticClass: "font-hemi-head",
                                  style: {
                                    fontSize: _vm.titoloFontSize + "px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  GESTIONALE LEGHE\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("h2", { staticClass: "font-hemi-head" }, [
                                _vm._v(
                                  "\n                  Fantapazz non è solo Asta LIVE!"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                  Scarica subito anche le nostre app di Gestione Leghe."
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                  Disponibili per Serie A, Champions League e Nazionali\n                  (Mondiali e Europei)\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "apps d-flex justify-center mt-2",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://fantapazz.com",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/static/img/icona-app-serie-a.png",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://championsleague.fantapazz.com",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/static/img/icona-app-champions.png",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://nations.fantapazz.com",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "/static/img/icona-app-nations.png",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h2",
                                { staticClass: "font-hemi-head" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "secondary--text" },
                                    [_vm._v("celebration")]
                                  ),
                                  _vm._v(
                                    " Asta\n                  Live è già integrata dentro il gestionale leghe!\n                "
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4", lg: "4" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "px-5 mt-n6 mt-md-n16 mt-lg-n16 d-flex justify-center",
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    "max-width": "400px",
                                    width: "100%",
                                  },
                                  attrs: {
                                    src: "/static/img/mockup-app-serie-a.png",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass: "white--text pa-4 font-hemi-head",
              style: { fontSize: _vm.sottoTitoloFontSizePx },
              attrs: { id: "prezzi" },
            },
            [_vm._v("\n      Prezzi\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pa-6" },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-auto card-prezzi",
                  attrs: { "max-width": "500" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "part-top px-6 pt-6" },
                    [
                      _c("h2", { staticClass: "py-4 font-hemi-head" }, [
                        _c("div", [_vm._v("Provala subito... GRATIS!")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("\n              FREE\n              "),
                          _c(
                            "span",
                            { staticClass: "secondary--text text-bigger" },
                            [
                              _vm._v(
                                _vm._s(_vm.Constants.NUM_ASSEGNAZIONI_FREE) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v("assegnazioni/asta\n            "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "py-4 px-10 white--text",
                          attrs: {
                            rounded: "",
                            depressed: "",
                            color: "secondary",
                          },
                          on: { click: _vm.gotoCreaAsta },
                        },
                        [_vm._v("PROVA GRATIS")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4" }, [
                        _vm._v("Prova gratuitamente ASTA LIVE:"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n            Potrai mettere all'asta e assegnare fino a\n            " +
                            _vm._s(_vm.Constants.NUM_ASSEGNAZIONI_FREE) +
                            " calciatori.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "(per ciascuna asta, in qualsiasi delle 4 modalità)"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4" }, [
                        _vm._v(
                          "\n            Dopodichè per continuare bisogna sbloccare l'asta.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n            Il prezzo per sbloccarla dipende dal numero massimo partecipanti\n            impostato nell'asta stessa:\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "white--text",
                              attrs: { small: "" },
                            },
                            [_vm._v("info")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {}, [_vm._v("IMPORTANTE")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n            L'asta viene pagata da una sola persona e si sblocca per tutti i\n            partecipanti\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "part-bottom pa-6" },
                    [
                      _c("tabella-prezzi", {
                        staticClass: "mt-4",
                        attrs: { dark: "" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("asta-footer", { attrs: { paddedTop: "", paddedBottom: "" } }),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.drawer,
              expression: "drawer",
            },
          ],
          staticClass: "home-drawer",
          attrs: { elevation: "12" },
        },
        [
          _c(
            "v-list-item",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { rounded: "", icon: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#modalita",
                      expression: "'#modalita'",
                    },
                  ],
                  attrs: { link: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("gavel"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Modalità d'asta")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#come-funziona",
                      expression: "'#come-funziona'",
                    },
                  ],
                  attrs: { link: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("info"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Come funziona")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#prezzi",
                      expression: "'#prezzi'",
                    },
                  ],
                  attrs: { link: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("euro"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold font-hemi-head" },
                        [_vm._v("Prezzi")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#leghe",
                      expression: "'#leghe'",
                    },
                  ],
                  attrs: { link: "" },
                  on: {
                    click: function ($event) {
                      _vm.drawer = false
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("shield"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold font-hemi-head" },
                        [_vm._v("Gestionali Leghe")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }